import React  from "react";
import { FormatMessage } from "react-globalize";
import { getBulletAndText, getListItems } from "../globalizationUtils";

export default function SectionPrivacy(props)
{
  let locale = props.locale || 'en';  

  return (
  <div id="privacy">
    <div className="title">
      <h3><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/title" /></h3>
    </div>

    <div id="privacyStatement" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyStatement", "quisqueyanaPolicy/privacy/PRIVACY_STATEMENT/title")}</h4>
      <div className="privacyStatement collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/PRIVACY_STATEMENT/info" /></p>
      </div>
    </div>

    <div id="privacyScope" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyScope", "quisqueyanaPolicy/privacy/SCOPE/title")}</h4>
      <div className="privacyScope collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/SCOPE/info"/></p>
      </div>
    </div>

    <div id="privacyPersonal" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyPersonal", "quisqueyanaPolicy/privacy/PERSONAL_INFORMATION/title")}</h4>
      <div className="privacyPersonal collapse collapsebleDiv">
        <p>
          <FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/PERSONAL_INFORMATION/info"/>
          <ul>
            {getListItems(locale, 5, "quisqueyanaPolicy/privacy/PERSONAL_INFORMATION/list", {bold: <strong></strong>})}
          </ul>
        </p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/PERSONAL_INFORMATION/info2"/></p>
      </div>
    </div>

    <div id="privacyHowCollects" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyHowCollects", "quisqueyanaPolicy/privacy/HOW_COLLECTS/title")}</h4>
      <div className="privacyHowCollects collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_COLLECTS/info"/></p>
        <ul>
          {getListItems(locale, 5, "quisqueyanaPolicy/privacy/HOW_COLLECTS/includedList")}
        </ul>
        <h5 className="subTitle"><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_COLLECTS/TECHNOLOGIES/title"/></h5>
        <ul>
          {getListItems(locale, 3, "quisqueyanaPolicy/privacy/HOW_COLLECTS/TECHNOLOGIES/includedList")}
        </ul>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_COLLECTS/note"/></p>
      </div>
    </div>

    <div id="privacyHowSecures" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyHowSecures", "quisqueyanaPolicy/privacy/HOW_SECURES/title")}</h4>
      <div className="privacyHowSecures collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_SECURES/info1"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_SECURES/info2"/></p>
        <h5 className="subTitle"><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_SECURES/TECHNOLOGIES/title"/></h5>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_SECURES/TECHNOLOGIES/info1"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_SECURES/TECHNOLOGIES/info2"/></p>
      </div>
    </div>

    <div id="privacyHOW_USES" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyHOW_USES", "quisqueyanaPolicy/privacy/HOW_USES/title")}</h4>
      <div className="privacyHOW_USES collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_USES/info"/></p>
        <ul>
          {getListItems(locale, 7, "quisqueyanaPolicy/privacy/HOW_USES/purposes", {bold: <strong></strong>} )}
        </ul>
      </div>
    </div>

    <div id="privacyLEGAL_BASES" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyLEGAL_BASES", "quisqueyanaPolicy/privacy/LEGAL_BASES/title")}</h4>
      <div className="privacyLEGAL_BASES collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/LEGAL_BASES/info"/></p>
        <ul>
          {getListItems(locale, 4, "quisqueyanaPolicy/privacy/LEGAL_BASES/includedList", {bold: <strong></strong>} )}
        </ul>
      </div>
    </div>

    <div id="privacyHOW_MARKETS" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyHOW_MARKETS", "quisqueyanaPolicy/privacy/HOW_MARKETS/title")}</h4>
      <div className="privacyHOW_MARKETS collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_MARKETS/info1"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/HOW_MARKETS/info2"/></p>
      </div>
    </div>

    <div id="privacyCHILDREN" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyCHILDREN", "quisqueyanaPolicy/privacy/CHILDREN/title")}</h4>
      <div className="privacyCHILDREN collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CHILDREN/info"/></p>
      </div>
    </div>

    <div id="privacyEXTERNAL" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyEXTERNAL", "quisqueyanaPolicy/privacy/EXTERNAL/title")}</h4>
      <div className="privacyEXTERNAL collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/EXTERNAL/info"/></p>
      </div>
    </div>

    <div id="privacyWHO" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyWHO", "quisqueyanaPolicy/privacy/WHO/title")}</h4>
      <div className="privacyWHO collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/WHO/info"/></p>
        <ul>
          {getListItems(locale, 8, "quisqueyanaPolicy/privacy/WHO/includedList" )}
        </ul>
      </div>
    </div>

    <div id="privacyINTERNATIONAL" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyINTERNATIONAL", "quisqueyanaPolicy/privacy/INTERNATIONAL/title")}</h4>
      <div className="privacyINTERNATIONAL collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/INTERNATIONAL/info"/></p>
      </div>
    </div>

    <div id="privacyRETENTION" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyRETENTION", "quisqueyanaPolicy/privacy/RETENTION/title")}</h4>
      <div className="privacyRETENTION collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/RETENTION/info"/></p>
      </div>
    </div>

    <div id="privacyCPI" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyCPI", "quisqueyanaPolicy/privacy/CHANGING_PERSONAL_INFORMATION/title")}</h4>
      <div className="privacyCPI collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CHANGING_PERSONAL_INFORMATION/info"/></p>
      </div>
    </div>

    <div id="privacyCONTACT_US" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyCONTACT_US", "quisqueyanaPolicy/privacy/CONTACT_US/title")}</h4>
      <div className="privacyCONTACT_US collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CONTACT_US/info1" elements={{email: <a className="strong" href="mailto:info@quisqueyana.com"></a>}}/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CONTACT_US/info2"/></p>
      </div>
    </div>

    <div id="privacyCHANGES" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyCHANGES", "quisqueyanaPolicy/privacy/CHANGES/title")}</h4>
      <div className="privacyCHANGES collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CHANGES/info"/></p>
      </div>
    </div>

    <div id="privacyPRIVACY_NOTICE" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyPRIVACY_NOTICE", "quisqueyanaPolicy/privacy/PRIVACY_NOTICE/title")}</h4>
      <div className="privacyPRIVACY_NOTICE collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/PRIVACY_NOTICE/info"/></p>
      </div>
    </div>

    <div id="privacyCALIFORNIA_PRIVACY" className="div">
      <h4 className="subTitle">{getBulletAndText(locale, "privacyCALIFORNIA_PRIVACY", "quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/title")}</h4>
      <div className="privacyCALIFORNIA_PRIVACY collapse collapsebleDiv">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/info1"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/rightToknow"/></p>
        <ul>
          {getListItems(locale, 5, "quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/includedList" )}
        </ul>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/info2"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/info3"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/note"/></p>
        <p>Quisqueyana</p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/addressLine2"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/phone" elements={{phone: <a className="strong" href="tel:+1- 866- 271- 3202"></a>}}/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/email"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/footNote"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/residents"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/personalinfo"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/submit/web" elements={{link: <a className="strong" href="https://www.barri.com/bfgDoNotSellMyPersonalInformation"></a>}}/></p>
        <div>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/title" /></p>
          <address><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/address" /></address>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/phone" elements={{phone: <a className="strong" href="tel:+18009262277"></a>}} /></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/web" elements={{link: <a className="strong" href="http://www.barri.com"></a>}} /></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/email" elements={{email: <a className="strong" href="mailto:info@barri.com"></a>}} /></p>
          <p><FormatMessage locale={locale} path="quisqueyanaPolicy/privacy/CALIFORNIA_PRIVACY/contactUs/dba" /></p>
        </div>
      </div>
    </div> 
  </div>
  )
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/SectionPrivacy/SectionPrivacy.js